import axios from "../interceptors";
import { apiGetSentComments } from "../../config";

export const getCommentsSent = async function (lang, entId, entType) {
  try {
    const response = await axios.get(
      apiGetSentComments + "/" + entId + "/" + entType,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    //This response just returns the rules
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      alert("Something went wrong with getting the file upload rules.");
    }
  } catch (error) {
    console.log(error.response.data.Messages);
  }
};
